export default __webpack_public_path__ + "static/media/logOut.70433eb5.svg";